/* globals $ Craft App */

import { Collapsible } from "./collapsible";
import { countryPopup } from "./country-popup";
import { languagePopup } from "./language-popup";

class Header {
  constructor() {
    new countryPopup(new languagePopup());
    this.$links = $("#header-nav .nav-more-link");
    this.$links.click((e) => {
      e.stopPropagation();
      this.openMore($(e.currentTarget));
    });
    this.$links.find(".nav-more-block").click((e) => {
      e.stopPropagation();
    });
    $("body").click(() => {
      this.$links.filter(".active").removeClass("active").find(".nav-more-block").slideUp();
    });
    this.$active = $("#mob-menu .mob-menu-active");
    this.$moreLinks = $("#mob-menu .mob-menu-more-link");
    this.$moreMenus = $("mob-menu .mob-menu-more");
    this.$searchResults = $("#search-results");
    this.$loader = $("#search-loader");
    this.$input = $("#search-form input");
    this.$form = $("#search-form");
    this.initSearch();
    this.initMobileNav();
    new Collapsible($("#mob-menu"));
    this.initHeaderForm();
  }

  openMore($link) {
    if ($link.hasClass("active")) {
      $link.removeClass("active").find(".nav-more-block").slideUp("fast");
      return;
    }
    let $active = this.$links.filter(".active");
    $link.addClass("active");
    if ($active.length) {
      $active.removeClass("active").find(".nav-more-block").fadeOut(200);
      $link.addClass("active").find(".nav-more-block").fadeIn(200);
    } else {
      $link.find(".nav-more-block").slideDown("fast");
    }
  }

  initSearch() {
    if (Craft.searchTerm) {
      $(".js-search-term").val(Craft.searchTerm);
    }
    $(".open-search").click((e) => {
      e.stopPropagation();
      this.$form.fadeIn("fast");
      this.$input.focus();
    });
    $(".close-search").click(() => {
      this.$input.focusout();
      this.$form.fadeOut("fast");
    });
    this.$input.keydown(() => {
      this.$searchResults.fadeOut();
    });
    this.$input.on("click", (e) => {
      e.stopPropagation();
    });
    this.$input.on("focus", (e) => {
      e.stopPropagation();
      if (this.$input.val()) {
        this.search();
      }
    });
    this.$input.keyup(() => {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(this.search.bind(this), 500);
    });
    $("body").click(() => {
      this.$searchResults.fadeOut();
    });
  }

  search() {
    let term = this.$input.val();
    if (term.length < 4) {
      this.$input.addClass("text-red-500");
      return;
    }
    this.$input.removeClass("text-red-500");
    this.$loader.show();
    $.ajax({
      url: Craft.currentSite.baseUrl + "?action=swissmed/search&term=" + term,
      method: "post",
      headers: {
        "X-CSRF-Token": Craft.csrfToken,
      },
    }).done((data) => {
      this.$searchResults.html(data).fadeIn("fast");
      this.$loader.hide();
    });
  }

  initHeaderForm() {
    if ($(".header-form.calculator").length) {
      import(/* webpackChunkName: "calculator-header-form" */ "./calculator-header-form").then((chunk) => {
        new chunk.HeaderFormCalculator($(".header-form.calculator"));
      });
    }
    $(".header-form .form-input input").change((e) => {
      let input = $(e.currentTarget);
      input.removeClass("has-value");
      if (input.val()) {
        input.addClass("has-value");
      }
    });
  }

  initMobileNav() {
    $("#open-burger-menu").click(() => {
      $("#mob-menu").fadeIn("fast");
      $("#open-burger-menu").toggle();
      $("#close-burger-menu").toggle();
      App.disableBodyScroll();
    });
    $("#close-burger-menu").click(() => {
      $("#mob-menu").fadeOut("fast");
      $("#open-burger-menu").toggle();
      $("#close-burger-menu").toggle();
      App.enableBodyScroll();
    });
  }
}

export { Header };
